import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import EmptyDashboard from './emptyDashboard/EmptyDashboard';
import PendingUserActions from './pendingUserActions';
import ActiveRequestActions from './activeRequestActions';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const DashboardView = props => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "row mt-4 mb-5",
      children: /*#__PURE__*/_jsxs("h1", {
        "data-id": "active-requests",
        className: "col-md-6 m-0",
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "dashboard.myActiveActions"
        }), /*#__PURE__*/_jsx("span", {
          className: "separator information",
          children: props.actionsCount
        })]
      })
    }), props.error ? /*#__PURE__*/_jsx("span", {
      "data-id": "error-message",
      children: /*#__PURE__*/_jsx(Translate, {
        value: "error.generic"
      })
    }) : props.loading ? /*#__PURE__*/_jsx("div", {
      className: "loading-overlay"
    }) : props.actionsCount === 0 ? /*#__PURE__*/_jsx(EmptyDashboard, {}) : null, /*#__PURE__*/_jsx(PendingUserActions, {
      onDataLoad: props.onPendingUsersDataLoad,
      onDataUpdate: props.onPendingUsersDataUpdate,
      onError: props.onPendingUsersError
    }), /*#__PURE__*/_jsx(ActiveRequestActions, {
      onDataLoad: props.onRequestsDataLoad,
      onDataUpdate: props.onRequestsDataUpdate,
      onError: props.onRequestsError
    })]
  });
};
DashboardView.propTypes = {
  actionsCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onPendingUsersDataLoad: PropTypes.func.isRequired,
  onRequestsDataLoad: PropTypes.func.isRequired,
  onPendingUsersDataUpdate: PropTypes.func.isRequired,
  onRequestsDataUpdate: PropTypes.func.isRequired,
  onPendingUsersError: PropTypes.func.isRequired,
  onRequestsError: PropTypes.func.isRequired
};
DashboardView.defaultProps = {
  loading: true,
  error: false
};
export default DashboardView;